import React from "react";

const AboutSlideTwo = () => {
  return (
    <div className="swiper-slide-section">
      <h2 className="highlighted">Hintergrund des Projektes</h2>
      <p>
        Die Anwendung ist im Rahmen des Moduls <b>Praxisseminar</b> des
        Lehrstuhls Medieninformatik (Fakultät für Informatik &amp; Data Science)
        der Universität Regensburg entstanden. An der Entwicklung beteiligt
        waren fünf Masterstudierende.
      </p>
      <p>
        Ziel der Anwendung ist es, den Alltag aller Studierenden und Lehrenden
        zu erleichtern &ndash; stets nach dem Motto:{" "}
        <b>"Digital is everywhere!"</b>
      </p>
      <p>
        Leider ist die Zuständigkeit für die Anwendung nach Abschluss des Moduls
        noch final geklärt, weshalb zum gegewertigen Zeitpunkt nicht abzusehen
        ist, wie es mit der Weiterentwicklung und Implementierung aller
        restlichen Funktionen weiter gehen wird.
      </p>
    </div>
  );
};

export default AboutSlideTwo;
